(function () {
  if (customElements.get('ce-product-sku') !== undefined) {
    return;
  }

  class ProductSKU extends HTMLParsedElement {
    constructor() {
      super();

      this.queuedAttributeChangedCallbackParams = [];

      this.selectors = {
        product: 'ce-product',
        target: '[data-product-sku-target]',
        json: '[data-product-sku-json]',
        template: '[data-product-sku-template]',
      };

      this.elements = null;
      this.variantSKUs = null;

      this.handleProductVariantId = this.handleProductVariantId.bind(this);
    }

    get variantId() {
      return this.getAttribute('variant-id');
    }

    set variantId(value) {
      this.setAttribute('variant-id', value);
    }

    static get observedAttributes() {
      return ['variant-id'];
    }

    attributeChangedCallback(...params) {
      if (!this.parsed) {
        this.queuedAttributeChangedCallbackParams.push(params);
        return;
      }

      const [name, oldValue, newValue] = params;

      if (oldValue === newValue) {
        return;
      }

      switch (name) {
        case 'variant-id':
          if (newValue !== null) {
            const sku = this.variantSKUs[newValue];

            if (sku === '') {
              this.elements.target.innerHTML = '';
            } else {
              const node = this.elements.template.content.cloneNode(true);

              const nodeSku = node.querySelector('[data-sku]');

              nodeSku.textContent = sku;

              this.elements.target.innerHTML = '';
              this.elements.target.appendChild(node);
            }
          }

          break;
      }
    }

    parsedCallback() {
      this.elements = {
        product: this.closest(this.selectors.product),
        target: this.querySelector(this.selectors.target),
        json: this.querySelector(this.selectors.json),
        template: this.querySelector(this.selectors.template),
      };

      this.variantSKUs = JSON.parse(this.elements.json.textContent);
      this.elements.json.remove();

      this.elements.product.addEventListener('ce-product:variant-id', this.handleProductVariantId);

      for (let params of this.queuedAttributeChangedCallbackParams) {
        this.attributeChangedCallback(...params);
      }
    }

    disconnectedCallback() {
      this.elements.product.removeEventListener('ce-product:variant-id', this.handleProductVariantId);
    }

    handleProductVariantId(event) {
      this.variantId = event.detail;
    }
  }

  customElements.define('ce-product-sku', ProductSKU);
})();
